

































import { Vue, Component } from "vue-property-decorator";
//import dataLearn from '../public/learn.json'
import mindmap from "./components/MindMap.vue";

@Component({ components: { mindmap } })
export default class App extends Vue {
  showSource = false;
  onboarding = 0;
  length = 3;
  mmdata = [];
  power = {
    power_share: "0",
    power_cooperation: "0",
    power_export: "0",
    power_price: "0",
    node_count: "-1",
  };
  items = [{ title: "template" }, { title: "script" }];
  /**
   * 编辑模式配置参数
   */
  // options = {
  //   gps: { value: true },
  //   fitView: { value: true },
  //   keyboard: { value: true },
  //   draggable: { value: true },
  //   showNodeAdd: { value: true },
  //   contextMenu: { value: true },
  //   zoomable: { value: true },
  //   showUndo: { value: true },
  //   download: { value: true },
  //   viewMode: { value: false},
  //   showBack: { value: true},
  //   zoomFit: { value: false}
  // }

  /**
   * 预览模式配置参数
   */
  // options = {
  //   gps: { value: true },
  //   fitView: { value: true },
  //   keyboard: { value: true },
  //   draggable: { value: false },
  //   showNodeAdd: { value: false },
  //   contextMenu: { value: false },
  //   zoomable: { value: true },
  //   showUndo: { value: false },
  //   download: { value: false },
  //   viewMode: { value: true},
  //   showBack: { value: true},
  //   zoomFit: { value: false}
  // }

  /**
   * 缩略图模式配置参数
   */
  //  options = {
  //   gps: { value: true },
  //   fitView: { value: true },
  //   keyboard: { value: false },
  //   draggable: { value: false },
  //   showNodeAdd: { value: false },
  //   contextMenu: { value: false },
  //   zoomable: { value: false },
  //   showUndo: { value: false },
  //   download: { value: false },
  //   viewMode: { value: true},
  //   showBack: { value: false},
  //   zoomFit: { value: true}
  // }

  /**
   *  分享模式配置参数
   */
  options = {
    gps: { value: true },
    fitView: { value: true },
    keyboard: { value: true },
    draggable: { value: true },
    showNodeAdd: { value: true },
    contextMenu: { value: true },
    zoomable: { value: true },
    showUndo: { value: true },
    download: { value: true },
    viewMode: { value: true },
    showBack: { value: false },
    zoomFit: { value: true },
    zoomMode: { value: false },
  };

  xSpacing = 50;
  ySpacing = 10;
  strokeWidth = 2;

  updateNodeName(...args: any) {
    //console.log('updateNodeName', ...args)
  }
  click() {}
  created() {
    const that = this;
    window.addEventListener("message", function (event) {
      if (event.data && event.data.data && !event.data.noInit) {
        that.mmdata = event.data.data;
        // that.$set(that, 'mmdata', event.data.data)
        that.power = event.data.power;
        if (event.data.isViewMode) {
          that.options.draggable.value = false;
          that.options.showNodeAdd.value = false;
          that.options.zoomMode.value = true;
        }
      }
    });
  }
}
